<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="title">TREE LORE</h1>
<p class="center"><strong>BY</strong></p>
<h2 class="title">FRANCIS GEORGE HEATH</h2>
<p class="center">Editor of<br/>Gilpin’s ‘Forest Scenery’<br/>Author of<br/>‘Our Woodland Trees,’ ‘Burnham Beeches,’ ‘The Fern Portfolio,<br/>‘The Fern World,’ ‘Tree Gossip,’ ‘Sylvan Spring,’ ‘Sylvan<br/>Winter,’ ‘Autumnal Leaves,’ ‘My Garden Wild,’ ‘The<br/>Green Gateway,’ ‘Peasant Life,’ ‘Garden Rockery,’<br/>‘The Fern Paradise,’ ‘Fairy Plants,’<br/>‘Our British Rural Life and Labour,’<br/>‘British Trees,’ ‘British Ferns,’<br/>&amp;c., &amp;c.<br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/logo.gif"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?2acd0d0b